// extracted by mini-css-extract-plugin
export var label = "_72-1";
export var reminder = "_72-0";